<mp-filter-group
  [filterName]="filterName()"
  [icon]="icon()"
  [searchable]="true"
  [searchFieldPlaceholder]="searchFieldPlaceholder()"
  [isExpanded]="isExpanded"
  [isSearchExpanded]="isSearchExpanded"
  (isExpandedChange)="onExpandedChange($event)"
  (isSearchExpandedChange)="onSearchExpandedChange($event)"
  (searchTermChange)="onSearchTermChange($event)"
>
  <div class="facet-selection-info" filter-group-selection-info>
    <ng-content select="[additional-context-selection-info]" />
    <mp-filter-badge [value]="selectionCount()" />
  </div>

  @if (selectionCount() > 0) {
    <mp-filter-clear-button filter-group-clear-filter-action (clearFilter)="clearSelection()" />
  }

  <mp-multi-selection-filter
    #multiSelectionFilter
    [options]="filterOptions()"
    [selectedValues]="selectedValues() || []"
    [optionLabelTemplate]="bucketTemplate ? bucketOptionLabelTemplate.template : undefined"
    (selectedValuesChange)="onSelectionChanged($event)"
    (optionSelect)="onBucketOptionSelect($event)"
  />

  <ng-content select="[additional-context-filter]" />

  @if (maxVisibleItems(); as maxVisibleItems) {
    <mp-show-all-options-button
      [(showAll)]="showAll"
      [totalItemsCount]="filteredBuckets().length"
      [maxVisibleItemsCount]="maxVisibleItems"
    />
  }
</mp-filter-group>

<ng-template
  #bucketOptionLabelTemplate="mpTypedTemplate"
  mpTypedTemplate
  [contextType]="multiSelectionFilter.optionLabelTemplateContextType"
  let-bucketOption
>
  <ng-container
    *ngTemplateOutlet="bucketTemplate || null; context: { $implicit: bucketByValueMap()[bucketOption.value] }"
  />
</ng-template>
